var spoiler_default = {
  "fontElementMap": "ojzs-",
  "hideText": "_7NYr3",
  "onHoverText": "xb1z5",
  "hideBlock": "DQEJ8",
  "smallBlur": "wiOBa",
  "mediumBlur": "zBisR",
  "largeBlur": "EW8Bo",
  "hideBlock_gallery": "XQz6K",
  "overlay": "Wb4RY",
  "overlay_gallery": "mrb8l",
  "revealSpoilerBtn": "sVIoo",
  "isMobile": "_6I7qD",
  "onHoverBtn": "yJGMG",
  "spoilerWrapper": "ag85b",
  "spoilerDescription": "rdwAI",
  "spoilerContainer": "uSr9J",
  "spoilerContainer_Gallery": "pCEf2"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
